import { useState } from "react";

import clsx from "clsx";

import FieldLabel from "../Field-Label";
import { Props } from "./types";

const TextInput = ({
  name,
  label,
  labelTags,
  required,
  error,
  help,
  placeholder,
  type = "text",
  ...controls
}: Props) => {
  const [focussed, setFocussed] = useState(false);

  const inputRef = "inputRef" in controls ? controls.inputRef : undefined;
  const value =
    "inputRef" in controls
      ? undefined
      : controls.value === undefined || controls.value === null
      ? ""
      : controls.value;

  const onChange =
    "inputRef" in controls
      ? undefined
      : (e: React.ChangeEvent<HTMLInputElement>) =>
          controls.onChange(e.target.value === "" ? null : e.target.value);

  return (
    <>
      <div onFocus={() => setFocussed(true)} onBlur={() => setFocussed(false)}>
        {label && (
          <FieldLabel
            name={name}
            label={label}
            focussed={focussed}
            error={!!error}
            required={required}
            tags={labelTags}
          />
        )}
        <div
          className={clsx(
            "flex",
            "items-center",
            "border-b-2",
            focussed
              ? "border-primary-main"
              : "border-gray-300 hover:border-gray-400"
          )}
        >
          <input
            ref={inputRef}
            id={name}
            name={name}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            aria-label={
              typeof label === "string"
                ? label
                : label
                ? undefined
                : "Search Box"
            }
            required={required}
            type={type}
            autoComplete={type === "password" ? "off" : "on"}
            className={clsx(
              "pl-2",
              "pt-1",
              "pb-0",
              "w-full",
              "outline-none",
              "flex-1",
              "text-gray-800",
              "border-transparent",
              "focus:border-transparent",
              "focus:ring-0"
            )}
          />
        </div>
      </div>
      {help && (
        <div
          className={clsx(
            "text-xs",
            !!error ? "text-error-dark" : "text-gray-700"
          )}
        >
          {help}
        </div>
      )}
      {error && <div className="text-error-dark text-xs">{error}</div>}
    </>
  );
};

export default TextInput;
